import React from "react";
import { useColetaPrevia } from "@hooks";
import { TipoPendenciaColetaPrevia } from "@services";
import CapturaFoto from "../captura-foto";

const CapturaDocumento = ({ idSolicitacao, cpf, setScreenToShow }) => {
  const { enviar } = useColetaPrevia(idSolicitacao, cpf);

  const handleConfirmar = async (foto) => {
    await enviar(TipoPendenciaColetaPrevia.DocumentoIdentificacao, foto);
    setScreenToShow("lobby");
  };

  return (
    <CapturaFoto
      tipoGuia="documento"
      facingModeInicial="environment"
      instrucao="Posicione o seu documento com foto aberto, dentro da área da câmera."
      altTextoPreview="Prévia do documento"
      onConfirmar={handleConfirmar}
    />
  );
};

export default CapturaDocumento;
